var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup48348(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0267c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68bbff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48348",
    "data-name": "Group 48348",
    transform: "translate(-948 -8437)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(948 8437)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M.76,7.353H5.272v13.5H.76V7.353ZM3.044.854A2.347,2.347,0,0,0,.5,3.185,2.323,2.323,0,0,0,2.989,5.514h.028A2.338,2.338,0,1,0,3.044.854ZM16.318,7.039a4.449,4.449,0,0,0-4.061,2.235V7.353h-4.5s.055,1.267,0,13.5h4.5V13.32a3.408,3.408,0,0,1,.15-1.1,2.466,2.466,0,0,1,2.313-1.635c1.625,0,2.281,1.24,2.281,3.051v7.221h4.5V13.116C21.5,8.974,19.285,7.039,16.318,7.039Z",
    transform: "translate(967.5 8456.146)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup48348);
export default __webpack_public_path__ + "static/media/Group 48348.5cf6024a6c259a410713215ced14941d.svg";
export { ForwardRef as ReactComponent };